import typewriterConfig from "../typewriter/typewriterConfig"
import data from '../data/data'
import { navigate } from "gatsby-link"
import segment from "../../common/extras/segment"

let dataArray = data()

//Split the HTML into data
const attachHtmlToChunksData = (html) => {
    const htmlChunks = html.split(`<hr>`)

    dataArray.forEach(obj => {
        htmlChunks.forEach(htmlChunk => {
            //NOTE: if HTML isn't attaching properly, its probably because the chunkId has too many <strong> tags.
            //Fix it in ghost
            if (htmlChunk.includes(`chunkId: "${obj.id}"`)) {
                if (!obj.html) {
                    obj.html = htmlChunk
                    //create html without the tags
                    obj.cleanHTML = htmlChunk.replace(/(<p><strong>chunkId:.+?<\/strong><\/p>)/g, "")

                    //Add the processedHTML for the body
                    typewriterConfig.addEvents({
                        chunk: obj,
                        print: true
                    })

                    //Add the processedHTML for the response
                    if (obj.buttons) {
                        obj.buttons.forEach(button => {
                            typewriterConfig.typeButtonText({
                                chunk: obj,
                                print: true,
                                button
                            })
                        })
                    }

                    //Swap out the find and replace lines
                    if (obj.replaceInProcessedHTML) {
                        const newStr = obj.processedHTML.body.replace(obj.replaceInProcessedHTML.find, obj.replaceInProcessedHTML.replace)
                        obj.processedHTML.body = newStr
                    }


                    return;
                }
            }
        })
    })
}

const createProgressData = () => {
    //Calculate the total number of characters
    let actualTotal = 0;
    dataArray.forEach(chunk => {
        if (chunk.isRenegadeOS) {
            actualTotal = actualTotal + chunk.html.length
        }
    })

    //Now calculate the percentage for each chunk
    let runningTotal = 0
    dataArray.forEach(chunk => {
        if (chunk.isRenegadeOS) {
            runningTotal = runningTotal + chunk.html.length
            chunk.progress = Math.ceil((runningTotal / actualTotal) * 100)
        }
        else chunk.progress = null
    })
}


const getChunk = (id) => {
    let chunk = null
    dataArray.forEach(obj => {
        if (obj.id === id) {
            chunk = obj
            return
        }
    })
    return chunk
}

const getChunkWithUid = (uid) => {
    let chunk = null
    dataArray.forEach(obj => {
        if (obj.uid === uid) {
            chunk = obj
            return
        }
    })
    return chunk
}

const goToNextChunk = ({nextState, setActiveChunk}) => {
    let nextChunk = getChunk(nextState)
    setActiveChunk(nextChunk)
}

const finishedTypingCallback = (data) => {
    const {
        activeChunk,
        setActiveChunk,
        setShowButtons,
        print,
        setOpenContents
    } = data
    const callback = () => {
        //Handle displaying the computer nerd note
        //UseEffect then updates the active chunk
        if (activeChunk().nextState) {
            if (activeChunk().pause) {
                window.setTimeout(() => {
                    goToNextChunk({
                        nextState: activeChunk().nextState,
                        setActiveChunk: setActiveChunk
                    })
                }, 1000)
            }
            else {
                goToNextChunk({
                    nextState: activeChunk().nextState,
                    setActiveChunk: setActiveChunk
                })
            }
        }
        else {
            if (print) {
                handleButtonClick({...data, buttonIndex: 0})
            } else {
                if (activeChunk().openContents) {
                    if (setOpenContents) {
                        window.setTimeout(() => {
                            setOpenContents(true)
                        }, 8000)
                    }
                }
                setShowButtons(true)
            }
        }
    }
    return callback
}

const startTypewriter = (data) => {
    const {
        activeChunk,
        activeTypewriter,
        setShowButtons,
        print,
    } = data

    if (activeTypewriter) {
        setShowButtons(false)
        typewriterConfig.addEvents({
            typewriter: activeTypewriter,
            chunk: activeChunk(),
            print,
            finishedCallback: finishedTypingCallback(data)
        })
    }
}

const handleButtonClick = (data) => {
    const {
        activeChunk,
        buttonIndex,
        setActiveChunk,
        setShowButtons,
        print,
        activeTypewriter,
        setChosenButton,
        setProgressValue
    } = data

    segment.trackButtonClickInTerminal({
        chunkName: activeChunk().id,
        chunkNumber: activeChunk().number,
        buttonIndex: buttonIndex
    })

    if (activeChunk().isRenegadeOS) {
        setProgressValue(activeChunk().progress)
    }
    else {
        setProgressValue(null)
    }

    setShowButtons(false)
    setChosenButton({
        chunkId: activeChunk().id,
        buttonIndex: buttonIndex
    })
    const button = activeChunk().buttons[buttonIndex]
    typewriterConfig.typeButtonText({
        typewriter: activeTypewriter,
        button: button,
        print,
        chunk: activeChunk(),
        finishedCallback: () => {
            //It's the last chunk
            if (activeChunk().isLastChunk) {
                // navigate('/story/page-1')
                window.location.href = 'https://nikkidurkin.medium.com/renegade-os-an-intellectual-adventure-833a50bdaa26'
            }
            else {
                goToNextChunk({
                    nextState: button.nextState,
                    setActiveChunk: setActiveChunk
                })
            }
        }
    })

}


const restartExperience = ({setActiveChunk, setTypewriterBlock}) => {
    const firstChunk = dataArray[0]
    setActiveChunk(firstChunk)
    setTypewriterBlock(firstChunk.typewriter)
}

const findChunkBefore = (chunkId) => {
    let prevChunk = null
    dataArray.forEach(chunk => {
        if (chunk.nextState && chunk.nextState === chunkId) {
            if (!chunk.ignoreOnPreload) {
                prevChunk = chunk
            }
        }
        else if (chunk.buttons) {
            chunk.buttons.forEach((btn, i) => {
                if (btn.nextState === chunkId) {
                    if (!chunk.ignoreOnPreload) {
                        prevChunk = chunk
                    }
                }
            })
        }
    })
    return prevChunk
}

const findFurthestChunkUid = (arrayOfChunkUids) => {
    let index = 0
    if (arrayOfChunkUids) {
        arrayOfChunkUids.forEach(uid => {
            dataArray.forEach((chunk, i) => {
                if (uid === chunk.uid) {
                    if (i >= index) {
                        index = i
                    }
                }
            })
        })
    }
    return dataArray[index].uid
}

const preloadContentBackwards = (startingChunkUidArray) => {
    //Find the chunk with that Uid, so you can use the id
    //All buttons and nextstate link to id, not uid. Uid is just used for saving
    const startingChunkUid = findFurthestChunkUid(startingChunkUidArray)

    let _startingChunkId = dataArray[0].id
    dataArray.forEach(chunk => {
        if (chunk.uid === startingChunkUid) {
            _startingChunkId = chunk.id
        }
    })

    let currentChunk = getChunk(_startingChunkId)
    let preloadedChunks = [currentChunk]
    while (currentChunk && currentChunk.id !== dataArray[0].id) {
        currentChunk = findChunkBefore(currentChunk.id)
        preloadedChunks.push(currentChunk)
    }

    return preloadedChunks.reverse()
}


export default {
    getChunk,
    getChunkWithUid,
    attachHtmlToChunksData,
    startTypewriter,
    handleButtonClick,
    restartExperience,
    createProgressData,
    preloadContentBackwards,
    finishedTypingCallback
}
